import axios from 'axios';
import {
  GET_SECONDARY_HOME_BANNER_REQUEST,
  GET_SECONDARY_HOME_BANNER_SUCCESS,
  GET_SECONDARY_HOME_BANNER_FAILURE,
} from 'Store/constants';

export const getSecondaryHomeBanner = () => async dispatch => {
  dispatch({
    type: GET_SECONDARY_HOME_BANNER_REQUEST,
  });

  try {
    const res = await axios.get('cms/textConfig/secondarybannerarea');

    dispatch({
      type: GET_SECONDARY_HOME_BANNER_SUCCESS,
      payload: res.data
    });

  } catch (error) {
    dispatch({
      type: GET_SECONDARY_HOME_BANNER_FAILURE,
      payload: error.response && error.response.data,
    });

    throw error;
  }
};